"use client";

import { c as _c } from "react/compiler-runtime";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useContext, useEffect } from "react";
import { twMerge } from "tailwind-merge";
import { mainNavigation } from "@lib/navigation";
import { DrawerContext } from "./drawer-context";
import DrawerEntry from "./drawer-entry";
export default function DrawerNavigation() {
  const $ = _c(17);
  const {
    closeDrawer,
    drawerIsOpen
  } = useContext(DrawerContext);
  let t0;
  let t1;
  if ($[0] !== drawerIsOpen) {
    t0 = () => {
      if (drawerIsOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    };
    t1 = [drawerIsOpen];
    $[0] = drawerIsOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  const t2 = !drawerIsOpen;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = twMerge("fixed left-0 top-0 z-50 hidden h-full w-full backdrop-blur-md", "not-group-aria-hidden:block not-group-aria-hidden:backdrop-blur-md");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== closeDrawer) {
    t4 = <div aria-hidden="true" onClick={closeDrawer} className={t3} />;
    $[4] = closeDrawer;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = twMerge("bg-teal-700 w-drawer fixed right-0 top-0 z-50 h-full overflow-y-scroll dark:bg-slate-800", "translate-x-(--width-drawer) not-group-aria-hidden:translate-x-0 transition-transform", "motion-reduce:transition-none");
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <XMarkIcon className="text-red h-8 w-8" />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== closeDrawer) {
    t7 = <button onClick={closeDrawer} aria-label={"St\xE4ng meny"} className="absolute right-4 top-4">{t6}</button>;
    $[8] = closeDrawer;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <nav className="flex flex-col gap-3 pt-12">{mainNavigation.map(_temp)}</nav>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <div aria-modal={true} className={t5}>{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t2 || $[14] !== t4 || $[15] !== t9) {
    t10 = <div className="group text-slate-50" aria-hidden={t2}>{t4}{t9}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}
function _temp(item) {
  return <DrawerEntry key={item.title} item={item} />;
}